import { addYears } from "date-fns";
import { parseToDate } from "./dateUtils";

/**
 * Bepaal het schooljaar en optioneel de klas op basis van leeftijd.
 * @param {string|Date} dateOfBirth
 * @param {Array} classrooms - met schoolYear.id, classType, className, grade
 * @param {Array} years - schooljaren met id, startDate, endDate
 */
const GetSchoolYear = (dateOfBirth, classrooms = [], years = []) => {
    const birthDate = parseToDate(dateOfBirth);
    if (!birthDate) {
        return {
            projectedYear: "—",
            label: "Unknown",
            className: "Unknown",
            classId: null,
            isEstimate: true,
        };
    }

    const fourthBirthday = addYears(birthDate, 4);

    if (!Array.isArray(years) || years.length === 0) {
        const fallback = `~${fourthBirthday.getFullYear()}/${fourthBirthday.getFullYear() + 1}`;
        // console.log(`[ESTIMATE] Geen schooljaren beschikbaar. Geschat jaar: ${fallback}`);
        return {
            projectedYear: fallback,
            label: `Unknown (${fallback})`,
            className: "Unknown",
            classId: null
        };
    }

    const matchingYear = years.find((y) => {
        const start = parseToDate(y.startDate);
        const end = parseToDate(y.endDate);
        if (!start || !end) return false;
        return fourthBirthday >= start && fourthBirthday <= end;
    });

    const estimatedYear = `~${fourthBirthday.getFullYear()}/${fourthBirthday.getFullYear() + 1}`;

    if (!matchingYear) {
        // console.log(`[ESTIMATE] Geen schooljaar gevonden voor ${fourthBirthday.toDateString()}, schatting: ${estimatedYear}`);
        return {
            projectedYear: estimatedYear,
            label: `Unknown (${estimatedYear})`,
            className: "Unknown",
            classId: null,
            isEstimate: true
        };
    }

    const startYear = parseToDate(matchingYear.startDate)?.getFullYear();
    const endYear = parseToDate(matchingYear.endDate)?.getFullYear();
    const hasCompleteRange = Number.isFinite(startYear) && Number.isFinite(endYear);
    const projectedYear = hasCompleteRange ? `${startYear}/${endYear}` : estimatedYear;
    // console.log(`[FOUND YEAR] ${projectedYear} matched met 4e verjaardag (${fourthBirthday.toDateString()})`);

    const matchingYearId = matchingYear?.id ?? matchingYear?.schoolYearId ?? matchingYear?.uuid;

    // Probeer bijpassende klas te vinden
    let classMatch = classrooms.find((c) => {
        const classroomYearId =
            c?.schoolYear?.id ??
            c?.schoolYearId ??
            c?.school_year_id ??
            c?.schoolYear?.schoolYearId ??
            c?.schoolYear?.school_year_id;

        return classroomYearId != null && matchingYearId != null
            ? String(classroomYearId) === String(matchingYearId)
            : false;
    });

    if (classMatch) {
        // console.log(`[CLASS FOUND] ${classMatch.className} gekoppeld aan ${projectedYear}`);
        return {
            projectedYear,
            label: projectedYear,
            schoolYear: matchingYear,
            schoolYearId: matchingYearId ?? null,
            className: classMatch.className,
            classId: classMatch.id,
            isEstimate: !hasCompleteRange
        };
    }

    // console.log(`[NO CLASS FOUND] Jaar ${projectedYear} bestaat, maar geen klas gevonden`);
    return {
        projectedYear,
        label: "Unknown",
        schoolYear: matchingYear,
        schoolYearId: matchingYearId ?? null,
        className: "Unknown",
        classId: null,
        isEstimate: !hasCompleteRange
    };
};

export default GetSchoolYear;
